import React, { useEffect, useState } from "react";
import {
  SuprSendProvider,
  useFeedClient,
  SuprSendFeedProvider,
} from "@suprsend/react";
import { useUserDetailsContext } from "../context/userDetailsContext";
import { useGetOrderMediaConfig } from "../views/PlaceOrderTest/queryHooks";
import { useNotificationSound } from "../utils/notificationSound";

interface SuprSendContextProps {
  children: React.ReactNode;
}

function NotificationHandler() {
  const feedClient = useFeedClient();
  const playNotification = useNotificationSound();

  useEffect(() => {
    if (!feedClient) return;

    const handleNotificationSound = () => {
      try {
        playNotification();
      } catch (error) {
        console.error("Failed to play notification sound:", error);
      }
    };

    feedClient.emitter.on("feed.new_notification", handleNotificationSound);

    return () => {
      feedClient.emitter.off("feed.new_notification", handleNotificationSound);
    };
  }, [feedClient, playNotification]);

  return null;
}

const SuprSendContext: React.FC<SuprSendContextProps> = ({ children }) => {
  const userDetails = useUserDetailsContext();
  const { data: mobileConfigs } = useGetOrderMediaConfig();
  const [isConfigLoaded, setIsConfigLoaded] = useState<boolean>(false);
  const publicApiKey = mobileConfigs?.suprsend_orca_public_api_key;

  useEffect(() => {
    if (mobileConfigs && publicApiKey) {
      setIsConfigLoaded(true);
    }
  }, [mobileConfigs, publicApiKey]);

  if (!userDetails?._id || !isConfigLoaded || !publicApiKey) {
    return <>{children}</>;
  }

  return (
    <SuprSendProvider publicApiKey={publicApiKey} distinctId={userDetails._id}>
      <SuprSendFeedProvider>
        <NotificationHandler />
        {children}
      </SuprSendFeedProvider>
    </SuprSendProvider>
  );
};

export default SuprSendContext;
